import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  InputLabel,
  Select,
  OutlinedInput,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
  Card,
  CardContent,
} from "@mui/material";
import styles from "../css/Form.module.css";

export default function Form({ onSubmitSuccess }) {
  const preguntas = [
    { id: 1, texto: "¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?", tipo: "si_no" },
    { id: 2, texto: "¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?", tipo: "si_no" },
    { id: 3, texto: "¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?", tipo: "si_no" },
    { id: 4, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?", tipo: "si_no" },
    { id: 5, texto: "¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA? ", tipo: "si_no" },
    { id: 6, texto: "¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?", tipo: "si_no" },
    { id: 7, texto: "¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?", tipo: "si_no" },
    { id: 8, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?", tipo: "si_no" },
    { id: 9, texto: "¿En el Plan municipal de intervenciones se tiene incluidas intervenciones y recursos del Gobierno municipal?", tipo: "si_no" },
    { id: 10, texto: "¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?", tipo: "texto" },
    { id: 11, texto: "¿En su municipio se han priorizado comunidades para intensificar las acciones?", tipo: "si_no" },
    { id: 12, texto: "¿Cuántas comunidades han sido priorizadas en su municipio?", tipo: "texto" },
    { id: 13, texto: "¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?", tipo: "texto" },
    { id: 14, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?", tipo: "texto" },
    { id: 15, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? ", tipo: "texto" },
    { id: 16, texto: "¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? ", tipo: "si_no" },
    { id: 17, texto: "¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?", tipo: "si_no" },
    { id: 18, texto: "¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?", tipo: "si_no" },
    { id: 19, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?", tipo: "texto" },
    { id: 20, texto: "¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?", tipo: "texto" },
    { id: 21, texto: "¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?", tipo: "texto" },
    { id: 22, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?", tipo: "texto" },
    { id: 23, texto: "¿En el municipio se cuenta con el registro de familias que han sido beneficiadas programas sociales o institucional?", tipo: "si_no" },
    { id: 24, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?", tipo: "texto" },
    { id: 25, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?", tipo: "texto" },
    { id: 26, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?", tipo: "texto" },
    { id: 27, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?", tipo: "texto" },
    { id: 28, texto: "¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?", tipo: "texto" },
    { id: 29, texto: "¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?", tipo: "texto" },
  ];

  const [formData, setFormData] = useState({
    departamento: "",
    municipio: "",
    respuestas: {},
  });

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [cuentaConMunicipios, setCuentaConMunicipios] = useState("si");
  const [loading, setLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [userLocation, setUserLocation] = useState(null);
  const [isActivePeriod, setIsActivePeriod] = useState(true);
  const [periodMessage, setPeriodMessage] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingPeriod, setCheckingPeriod] = useState(true);
  const [municipioAlreadyResponded, setMunicipioAlreadyResponded] = useState(false);



  useEffect(() => {
    const verificarAlCargar = async () => {
      if (formData.departamento && formData.municipio) {
        await verificarRespuestaMunicipio();
      }
    };

    verificarAlCargar();
  }, [formData.departamento, formData.municipio, isAdmin]);

  useEffect(() => {
    if (formData.departamento && formData.municipio) {
      verificarRespuestaMunicipio();
    }
  }, [checkingPeriod]);

  const verificarRespuestaMunicipio = async () => {
    try {
      if (!formData.departamento || !formData.municipio) {
        setMunicipioAlreadyResponded(false);
        return;
      }

      const res = await fetch(
        `/check-municipio-response/${formData.departamento}/${formData.municipio}`
      );
      
      if (!res.ok) {
        if (res.status === 404) {
          // No existe respuesta anterior
          setMunicipioAlreadyResponded(false);
          return;
        }
        throw new Error(`Error HTTP: ${res.status}`);
      }

      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        console.warn("Respuesta no es JSON, asumiendo sin respuesta previa");
        setMunicipioAlreadyResponded(false);
        return;
      }

      const data = await res.json();
      setMunicipioAlreadyResponded(data.exists && !isAdmin);
      
      if (data.exists && !isAdmin) {
        setSnackbar({
          open: true,
          message: "⚠️ Ya se ha enviado una respuesta para este municipio este mes",
          severity: "warning"
        });
      }
    } catch (err) {
      console.error("Error verificando respuesta de municipio:", err);
      setMunicipioAlreadyResponded(false);
    }
  };



  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    fetch(`/user-location?username=${user.username}`)
      .then(res => res.json())
      .then(data => {
        setUserLocation(data);

        if (data.type === "municipality") {
          setFormData(prev => ({
            ...prev,
            departamento: data.departamentoId,
            municipio: data.municipioId
          }));
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    fetch(`/departamentos`)
      .then((res) => res.json())
      .then((data) => setDepartamentos(data))
      .catch((err) => console.error("Error al cargar departamentos:", err));
  }, []);

  useEffect(() => {
    if (formData.departamento) {
      fetch(`/municipios/${formData.departamento}`)
        .then((res) => res.json())
        .then((data) => setMunicipios(data))
        .catch((err) => console.error("Error al cargar municipios:", err));
    } else {
      setMunicipios([]);
      setFormData((prev) => ({ ...prev, municipio: "" }));
    }
  }, [formData.departamento]);

  useEffect(() => {
    if (formData.municipio) {
      verificarRespuestaMunicipio();
    } else {
      setMunicipioAlreadyResponded(false);
    }
  }, [formData.municipio, isAdmin]);

  const handleRespuestaChange = (id, valor) => {
    setFormData((prev) => ({
      ...prev,
      respuestas: { ...prev.respuestas, [id]: valor },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!isActivePeriod && !isAdmin) {
      setSnackbar({
        open: true,
        message: "No se puede enviar el formulario fuera del periodo activo",
        severity: "warning",
      });
      return;
    }

    if (municipioAlreadyResponded && !isAdmin) {
      setSnackbar({
        open: true,
        message: "Ya se ha enviado una respuesta para este municipio este mes",
        severity: "warning",
      });
      return;
    }
    
    setConfirmDialog(true);
  };

  const handleConfirmSubmit = async () => {
    setConfirmDialog(false);

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setSnackbar({
        open: true,
        message: "Debes iniciar sesión antes de enviar datos.",
        severity: "error",
      });
      return;
    }

    if (cuentaConMunicipios === "no") {
      setSnackbar({
        open: true,
        message: "Respuesta guardada (sin municipios priorizados).",
        severity: "success",
      });
      return;
    }

    if (!formData.departamento || !formData.municipio) {
      setSnackbar({
        open: true,
        message: "Selecciona un departamento y al menos un municipio.",
        severity: "warning",
      });
      return;
    }

    const faltantes = preguntas.filter((p) => !formData.respuestas[p.id]);
    if (faltantes.length > 0) {
      setSnackbar({
        open: true,
        message: "Responde todas las preguntas antes de guardar.",
        severity: "warning",
      });
      return;
    }

    setLoading(true);

    try {
      const respuestasConvertidas = {};
      Object.entries(formData.respuestas).forEach(([key, value]) => {
        respuestasConvertidas[key] = value === "si" ? "Si" : value === "no" ? "No" : value;
      });

      const payload = {
        userId: user.id,
        departamento: formData.departamento,
        municipio: formData.municipio,
        respuestas: respuestasConvertidas,
      };

      const res = await fetch(`/respuestas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        
        if (res.status === 409) {
          throw new Error(`❌ ${errorData.error}`);
        }
        throw new Error(errorData.error || "Error al guardar los datos");
      }

      const result = await res.json();

      setSnackbar({
        open: true,
        message: `✅ Datos guardados correctamente. ${result.isAdmin ? '(Modo administrador)' : ''}`,
        severity: "success",
      });

      setFormData(prev => ({
        departamento: userLocation?.type === "municipality" ? prev.departamento : "",
        municipio: userLocation?.type === "municipality" ? prev.municipio : "",
        respuestas: {}
      }));

      setMunicipioAlreadyResponded(true);
      
      if (onSubmitSuccess) onSubmitSuccess();
    } catch (err) {
      console.error("Error al guardar datos:", err);
      setSnackbar({
        open: true,
        message: err.message || "Error al guardar los datos.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const handleCargarRespuestasPrevias = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !formData.departamento || !formData.municipio) {
      setSnackbar({
        open: true,
        message: "No hay información suficiente para cargar respuestas.",
        severity: "warning"
      });
      return;
    }

    try {
      const res = await fetch(
        `/respuestas/${user.id}/${formData.departamento}/${formData.municipio}`
      );
      const data = await res.json();

      if (data.success && data.respuestas) {
        const respuestasNormalizadas = {};
        Object.entries(data.respuestas).forEach(([key, value]) => {
          if (value === "Si") respuestasNormalizadas[key] = "si";
          else if (value === "No") respuestasNormalizadas[key] = "no";
          else respuestasNormalizadas[key] = value;
        });

        setFormData(prev => ({
          ...prev,
          respuestas: respuestasNormalizadas
        }));

        setSnackbar({
          open: true,
          message: "Respuestas anteriores cargadas.",
          severity: "success"
        });
      } else {
        setSnackbar({
          open: true,
          message: "No se encontraron respuestas anteriores.",
          severity: "info"
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Error al cargar respuestas anteriores.",
        severity: "error"
      });
    }
  };


  return (
    <Paper elevation={6} className={styles.paper}>
      <Typography variant="h5" gutterBottom className={styles.title}>
        Ingresar Nueva Respuesta
        {isAdmin && " (Modo Administrador)"}
      </Typography>

      {municipioAlreadyResponded && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          ⚠️ Este municipio ya tiene una respuesta registrada este mes.
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} className={styles.formContainer}>
        <FormControl component="fieldset" sx={{ mb: 2 }}>
          <FormLabel component="legend">¿Cuenta con municipios priorizados?</FormLabel>
          <RadioGroup
            row
            value={cuentaConMunicipios}
            onChange={(e) => setCuentaConMunicipios(e.target.value)}
          >
            <FormControlLabel value="si" control={<Radio />} label="Sí" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>


          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                select
                label="Departamento"
                value={formData.departamento}
                disabled={userLocation?.type === "municipality"}
                onChange={(e) =>
                  setFormData(prev => ({
                    ...prev,
                    departamento: e.target.value,
                    municipio: ""
                  }))
                }
                required
              >
                {departamentos.map((dep) => (
                  <MenuItem key={dep.departamentoId} value={dep.departamentoId}>
                    {dep.departamentoName}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="municipios-label">Municipio</InputLabel>
              <Select
                labelId="municipios-label"
                value={formData.municipio}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, municipio: e.target.value }))
                }
                input={<OutlinedInput label="Municipio" />}
                disabled={
                  userLocation?.type === "municipality" ||
                  !formData.departamento
                }
                error={municipioAlreadyResponded}
              >
                {municipios.map((mun) => (
                  <MenuItem
                    key={mun.municipioId}
                    value={mun.municipioId}
                  >
                    {mun.municipioName}
                  </MenuItem>
                ))}
              </Select>

              <Button
                variant="outlined"
                sx={{ mt: 2 }}
                onClick={handleCargarRespuestasPrevias}
                disabled={!formData.departamento || !formData.municipio || !userLocation || municipioAlreadyResponded}
              >
                Cargar respuesta anterior Autorizada
              </Button>
            </FormControl>
          </>


        { preguntas.map((pregunta) => (
            <Box key={pregunta.id} sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {pregunta.id}. {pregunta.texto}
              </Typography>
              {pregunta.tipo === "si_no" ? (
                <RadioGroup
                  row
                  value={formData.respuestas[pregunta.id] || ""}
                  onChange={(e) => handleRespuestaChange(pregunta.id, e.target.value)}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Sí" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              ) : (
                <TextField
                  fullWidth
                  placeholder="Ingrese su respuesta"
                  value={formData.respuestas[pregunta.id] || ""}
                  onChange={(e) => handleRespuestaChange(pregunta.id, e.target.value)}
                  type="number"
                  onWheel={(e) => e.target.blur()}
                />
              )}
            </Box>
          ))}

        <Box sx={{ mt: 3 }}>
          <Button 
            type="submit" 
            variant="contained" 
            fullWidth 
            disabled={loading || (municipioAlreadyResponded && !isAdmin)}
            className={styles.submitButton}
          >
            {loading ? "Guardando..." : 
             municipioAlreadyResponded && !isAdmin ? "✅ Municipio ya respondido" : "Guardar"}
          </Button>
        </Box>
      </Box>

      <Dialog open={confirmDialog} onClose={() => setConfirmDialog(false)}>
        <DialogTitle>Confirmar envío</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro de que desea enviar las respuestas?  
            Revise los datos antes de confirmar.
            {isAdmin && <><br/><strong>Modo administrador: Sin restricciones de tiempo</strong></>}
            {municipioAlreadyResponded && isAdmin && <><br/><strong>⚠️ Este municipio ya tiene respuesta (modo admin permite reemplazar)</strong></>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog(false)} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmSubmit}
            color="primary"
            variant="contained"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}